import React from 'react';
import Slider from 'react-slick';
import './Carousel.css';

const Carousel = ({ title, children }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3, // Mostrar 3 elementos por defecto en pantallas grandes
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767, // Para dispositivos móviles
        settings: {
          slidesToShow: 1, // Mostrar 1 elemento en pantallas pequeñas
        },
      },
      {
        breakpoint: 1024, // Para pantallas de hasta 1023px
        settings: {
          slidesToShow: 2, // Mostrar 2 elementos en pantallas medianas
        },
      },
      {
        breakpoint: 1440, // Para pantallas entre 1024px y 1439px
        settings: {
          slidesToShow: 2, // Mostrar 2 elementos
        },
      },
      {
        breakpoint: 1441, // Para pantallas grandes a partir de 1440px
        settings: {
          slidesToShow: 3, // Mostrar 3 elementos
        },
      },
    ],
  };

  // Verificar si settings está definido correctamente
  if (!settings) {
    console.error('Settings are not defined properly!');
  }

  return (
    <div className="carousel-container">
      <h2>{title}</h2>
      <Slider {...(settings || {})}>{children}</Slider> {/* Protección en caso de undefined */}
    </div>
  );
};

export default Carousel;
